export default {
  width: 24,
  height: 21,
  svg: `
    <path d="M.55 9.55C.55 4.12 5.846 0 12 0c6.153 0 11.45 4.12 11.45 9.55v.014a8.617 8.617 0 0 1-2.42 5.869l.513 4.452a1 1 0 0 1-1.363 1.044l-5.328-2.122c-.935.181-1.885.28-2.838.293H12C5.846 19.1.55 14.98.55 9.55ZM12 2C6.563 2 2.55 5.575 2.55 9.55c0 3.973 4.01 7.547 9.443 7.55a14.12 14.12 0 0 0 2.743-.31 1 1 0 0 1 .579.049l4.05 1.613-.379-3.277a1 1 0 0 1 .318-.852 6.616 6.616 0 0 0 2.146-4.78C21.445 5.571 17.433 2 12 2Z"/>
  `
}
